import {
  Component,
  ComponentFactoryResolver,
  ViewContainerRef,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Auth0Service } from 'src/app/shared/services/auth0.service';
import { loadSavedQuery } from 'src/app/shared/utils';
import { SwitchAppService } from 'src/app/switch-app.service';
import { environment } from 'src/environments/environment';
import { AppType } from 'src/environments/environmentTypes';
import { VEmail } from '../../landing/landing.interface';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css'],
})
export class VerifyEmailComponent {
  state: string;
  clientId: string;
  constructor(
    private service: Auth0Service,
    activeRoute: ActivatedRoute,
    private title: Title,
    private resolve: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private switchApp: SwitchAppService
  ) {
    const savedQuery = loadSavedQuery();
    if (savedQuery) {
      const keys = Object.keys(savedQuery);
      if (!location.search) {
        location.search = keys.map((k) => `${k}=${savedQuery[k]}`).join('&');
      }
      this.clientId = savedQuery.client_id;
    } else {
      activeRoute.queryParams.subscribe((queryParams) => {
        this.init(queryParams as VEmail);
        this.clientId = queryParams['client_id'];
      });
    }

    const app = this.applications.find((e) => e.clientId === this.clientId);
    if (app) {
      this.switchApp.setComponent(
        this.clientId,
        app.type,
        viewContainerRef,
        resolve,
        'emailSend'
      );
    }
  }

  init(queryParams: VEmail) {
    // setTimeout(() => {
    //   this.initialized = true;
    // }, 1000);
  }

  get applications(): {
    clientId: string;
    domain: string;
    logo: string;
    title: string;
    pageTitle: string;
    type: AppType;
  }[] {
    const result: any[] = [];
    for (const clientId of Object.keys(environment.apps)) {
      const app = environment.apps[clientId];
      app.clientId = clientId;
      result.push(app);
    }
    return result;
  }

  get isStation(): boolean {
    return /dstation/g.test(
      this.applications.find((app) => app.clientId === this.clientId).type
    );
  }
}
